import type { AcknowledgementDefinitionsList, Nullable } from "../types";
import { getMissingAcknowledgementDefinitionIds } from "./get-missing-acknowledgement-definition-ids";

/**
 * Whether the user ticked every acknowledgement definition the worksite requires.
 *
 * A worksite without definitions asks for nothing, so an empty list is complete — the same rule
 * the server applies when it decides whether a check-in body is missing an acknowledgement.
 *
 * @param definitions - The definitions required for the worksite, as the requirements returned them.
 * @param acknowledgedDefinitionIds - The definition ids the user ticked.
 * @returns `true` when nothing required is missing.
 */
export function getHasAllRequiredAcknowledgements(
	definitions: Nullable<AcknowledgementDefinitionsList>,
	acknowledgedDefinitionIds: Nullable<string[]>,
): boolean {
	return (
		getMissingAcknowledgementDefinitionIds(definitions, acknowledgedDefinitionIds).length === 0
	);
}
